import React, { createContext, useContext, useRef, useState, useCallback, useMemo } from 'react';

const LoaderContext = createContext(null);

export function LoaderProvider({ children }) {
  const counterRef = useRef(0);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('Loading...');

  const shouldDebug = process.env.REACT_APP_LOADER_DEBUG === 'true';

  const showLoader = useCallback((msg) => {
    counterRef.current += 1;
    if (shouldDebug) console.debug('[Loader] show ->', counterRef.current, msg || '');
    if (msg) setMessage(msg);
    setVisible(true);
  }, [shouldDebug]);

  const hideLoader = useCallback(() => {
    counterRef.current = Math.max(0, counterRef.current - 1);
    if (shouldDebug) console.debug('[Loader] hide ->', counterRef.current);
    if (counterRef.current === 0) {
      setVisible(false);
      setMessage('Loading...');
    }
  }, [shouldDebug]);

  const setLoaderMessage = useCallback((msg) => {
    if (shouldDebug) console.debug('[Loader] setMessage ->', msg);
    setMessage(msg || 'Loading...');
  }, [shouldDebug]);

  const value = useMemo(() => ({ visible, message, showLoader, hideLoader, setLoaderMessage }), [visible, message, showLoader, hideLoader, setLoaderMessage]);

  return (
    <LoaderContext.Provider value={value}>
      {children}
    </LoaderContext.Provider>
  );
}

export function useLoader() {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error('useLoader must be used within a LoaderProvider');
  return ctx;
}
